function ajax_blog_page(page){
    let cat_input = $('#blog_cat');
    let cat = cat_input.val();
    let getParameter = '?page_num='+page;
    let search_val =  $('#blog-search-value').val();
    if(search_val){
        getParameter += '&search='+search_val;
    }

    let data = {
        cat: cat ?? '',
        search: search_val,
        page: page,
        action: 'ajax_blog_page'
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data, function(response) {
        if(response){
            $('#blog_loop').html(response);
            window.history.replaceState( {} , '', getParameter );
            lazyLoadInstance.update();
        }
    });
}

$('.js-copy-link').click(async function () {
    const shareData = {
        title: $(this).data('title'),
        text: $(this).data('text'),
        url: $(this).data('url')
    };
    try {
        await navigator.share(shareData);
    } catch (err) {
        await navigator.clipboard.writeText(shareData.url);
        notif('success', $(this).data('success-text'));
    }
});
